export var UserType;
(function (UserType) {
    UserType[UserType["AUTHENTICATED"] = 1] = "AUTHENTICATED";
    UserType[UserType["UNAUTHENTICATED"] = 2] = "UNAUTHENTICATED";
    UserType[UserType["PENDING"] = 4] = "PENDING";
    UserType[UserType["PENDING_DELETE"] = 5] = "PENDING_DELETE";
    UserType[UserType["DELETED"] = 99] = "DELETED";
})(UserType || (UserType = {}));
//# sourceMappingURL=user-type.enum.js.map